import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Popup from '../../components/Popup/Popup';

import styles from './settings.scss';

export default function RolesInfo(props) {
    const { onClosed } = props;
    const { t } = useTranslation();

    return (
        <Popup noConfirm={true} cancelText={'Закрыть'} title="Роли" onClosed={onClosed}>
            <div className={styles.rolesDescription}>
                <h2 className={styles.roleName}>{t('settings.role.manager')}</h2>
                <ul>
                    <li>{t('settings.permission.products')}</li>
                    <li>{t('settings.permission.clients')}</li>
                </ul>
                <h2 className={styles.roleName}>{t('settings.role.admin')}</h2>
                <ul>
                    <li>{t('settings.permission.includesManager')}</li>
                    <li>{t('settings.permission.editClient')}</li>
                    <li>{t('settings.permission.refunds')}</li>
                    <li>{t('settings.permission.retryPayments')}</li>
                    <li>{t('settings.permission.addManagers')}</li>
                </ul>
            </div>
        </Popup>
    );
};

RolesInfo.propTypes = {
    onClosed: PropTypes.func.isRequired,
};
